import { TagTextAlert, TextExternalLink, Span } from "@bridgesplit/ui";
import { PandoraErrorCodes } from "@bridgesplit/utils";
import { getPandoraErrorCode } from "@bridgesplit/abf-react";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query/fetchBaseQuery";

export function PandoraQuoteError({
    externalQuoteError
}: {
    externalQuoteError: FetchBaseQueryError | SerializedError;
}) {
    const errorCode = getPandoraErrorCode(externalQuoteError);
    const { preLinkText, linkUrl, linkText } = getErrorHelpInfo(errorCode);

    return (
        <TagTextAlert color="error" icon="warning">
            <Span>
                {preLinkText}
                <TextExternalLink
                    href={linkUrl}
                    sx={{ color: "secondary.main", display: "inline" }}
                    isPrimary
                    underlineLink
                >
                    {linkText}
                </TextExternalLink>
            </Span>
        </TagTextAlert>
    );
}

interface MappedErrorInfo {
    preLinkText: string;
    linkUrl: string;
    linkText: string;
}

function getErrorHelpInfo(errorCode: PandoraErrorCodes | undefined): MappedErrorInfo {
    switch (errorCode) {
        case PandoraErrorCodes.JUPITER_NO_ROUTES_FOUND:
        default:
            return {
                preLinkText:
                    "Unable to find a swap route through our integration partners. Please check back later or ",
                linkUrl: "https://docs.loopscale.com/using-loopscale/loop#manually-close",
                linkText: "manually manage your position."
            };
    }
}
